import React, { useState, useEffect, useRef } from "react";
import {
  useApolloClient,
  useMutation,
  useLazyQuery,
  useQuery,
} from "@apollo/client";
import { useHistory } from "react-router-dom";
import { Container } from "./Styled";
import { Header } from "./Header";
import { VoucherInformation } from "./VoucherInformation";
import { OrderHistory } from "./OrderHistory";
import { AuthorizationDetails } from "./AuthorizationDetails";
import { ShowNull } from "./ShowNull";
import { api } from "data/apollo/api";
import { LogoAnim } from "core/components/LogoAnim";
import { ErrorScreen } from "core/components/ErrorScreen";
import Button from "react-bootstrap/Button";

export const Print: React.FC = (props: any) => {
  const { location } = props;
  const client = useApolloClient();
  client.query({ query: api.remote.query.makes });
  const signature = useRef("");
  const times = useRef({ startTime: 0, endTime: 0 });
  const history = useHistory();
  const [showNull, setShowNull] = useState(false);
  const dataValues = location.state?.dataValues || {};
  const [setPrint] = useMutation(api.remote.mutation.setVoucherPrinted, {
    variables: {
      voucherid: dataValues.voucherid,
      VoucherPrinted: true,
      VoucherSignature: signature.current,
    },
    onCompleted: () => {
      location.state.dataValues = { redirect: true };
    },
  });

  const {
    loading: dealerLoading,
    error: dealerError,
    data: dealerData,
  } = useQuery(api.remote.query.dealerInfo, {
    variables: {
      clientid: dataValues.clientid,
    },
  });

  const [findVoucher] = useLazyQuery(api.remote.query.findVoucher, {
    variables: { voucherid: dataValues.voucherid },
    onCompleted: (resp) => {
      if (!resp.getVoucher) {
        history.replace("/");
      }
    },
  });

  useEffect(() => {
    const mediaQueryList = window.matchMedia("print");
    let canSend = true;
    let showNull = true;
    const watchPrint = async (mql: any) => {
      if (!mql.matches) {
        times.current.startTime = Date.now();
        if (canSend) {
          canSend = false;
          const data: any = {
            voucherid: dataValues.voucherid,
          };
          if (signature) data.VoucherSignature = signature.current;
          try {
            setPrint();
          } catch (e) {}
        }
      } else {
        times.current.endTime = Date.now();
        if (showNull) {
          showNull = false;
          mediaQueryList.removeEventListener("print", watchPrint);
          setTimeout(() => {
            setShowNull(true);
          }, 500);
        }
      }
    };
    mediaQueryList.addListener(watchPrint);
    return () => mediaQueryList.removeEventListener("print", watchPrint);
  }, []);

  const handlePrint = () => {
    window.print();
  };

  useEffect(() => {
    async function getVoucher() {
      if (dataValues.voucherid) {
        findVoucher();
      }
    }
    getVoucher();
  }, [dataValues.voucherid]);

  if (JSON.stringify(dataValues) === "{}") {
    history.push("/");
  }

  if (showNull) {
    return <ShowNull times={times.current} />;
  }

  if (dealerLoading) {
    return <LogoAnim />;
  }

  if (dealerError) {
    return <ErrorScreen />;
  }

  return (
    <Container>
      <div
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-end",
          alignItems: "flex-end",
        }}
      >
        <Button
          disabled={JSON.stringify(location.state) === "{}"}
          onClick={handlePrint}
          size="lg"
          style={{ width: "150px", marginBottom: 20 }}
        >
          Print
        </Button>
      </div>

      {/*------ Top Section ------ */}
      <div
        style={{
          height: 700,
          borderBottom: "2px dashed black",
          marginBottom: 10,
          marginTop: 10,
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "column",
        }}
      >
        <div>
          <Header data={dealerData} showAddress={true} />
          <VoucherInformation {...dataValues} />
          <AuthorizationDetails {...dataValues} showSignature />
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            width: "100%",
            flexDirection: "column",
          }}
        >
          <strong
            style={{
              textTransform: "uppercase",
              fontSize: 24,
              alignSelf: "center",
              paddingBottom: 5,
            }}
          >
            NOTE: PURCHASE VOUCHER ONLY VALID ON DATE OF ISSUE
          </strong>
          <p style={{ fontSize: 12 }}>Powered by DealerOps</p>
        </div>
      </div>

      {/*------ Bottom Section ------ */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          flexDirection: "column",
        }}
      >
        <div
          style={{
            marginTop: 50,
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <strong style={{ fontSize: 20 }}>Fuel Purchase Voucher</strong>
          <strong style={{ fontSize: 20 }}>Remittance Advice</strong>
        </div>
        <div>
          <Header showAddress={false} data={dealerData} />
          <VoucherInformation {...dataValues} />
          <AuthorizationDetails {...dataValues} />
          <strong
            style={{
              fontSize: "1rem",
              alignSelf: "center",
            }}
          >
            Comments:
          </strong>
          <OrderHistory currentVoucher={dataValues} />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            width: "100%",
            flexDirection: "column",
          }}
        >
          <strong
            style={{
              textTransform: "uppercase",
              fontSize: 24,
              alignSelf: "center",
              paddingBottom: 5,
              paddingTop: 10,
            }}
          >
            NOTE: PURCHASE VOUCHER ONLY VALID ON DATE OF ISSUE
          </strong>
          <p style={{ fontSize: 12 }}>Powered by DealerOps</p>
        </div>
      </div>
    </Container>
  );
};
